export default function responsiveValues (width) {
    let object
    //Mobiles
    if (width < 720) {
        object = {
            //INITIAL SETS
            objPosX: 0,
            objPosY: -8,
            objPosZ: -18,

            objRotX: Math.PI/2,
            objRotY: 0,
            objRotZ: 0,

            //Entry Animation
            entryObjPosY: 0,

            //Components Part
            ComponentsPosX: 2,
            ComponentPosZ: -20,
            ComponentPosY: -20,

            ComponentsRotX: Math.PI/2,
            ComponentsRotY: 0,
            ComponentsRotZ: Math.PI/2,

            ComponentCameraPosY: 1.1,
            // WorkingPosX: -3,
            // WorkingPosZ: -54,
            // WorkingRotX: -Math.PI,
            // WorkingRotY: Math.PI/2,
            // WorkingRotZ: Math.PI,
            // workingCameraPosY: -1.73,

            CameraPosY: 12,
        }
    }
    //Tablets
    else if (width >= 720 && width < 1024) {
        object = {
            objPosX: 1.5,
            objPosY: -10,
            objPosZ: -15,

            objRotX: Math.PI/2,
            objRotY: -Math.PI/8,
            objRotZ: 0,

            entryObjPosY: 1.5,

            ComponentsPosX: 0,
            ComponentPosZ: -25,
            ComponentPosY: -10,

            ComponentsRotX: Math.PI/2,
            ComponentsRotY: 0,
            ComponentsRotZ: -Math.PI/2,

            ComponentCameraPosY: 0.3,
            // WorkingPosX: -2.8,
            // WorkingPosZ: -30,
            // WorkingRotX: -Math.PI,
            // WorkingRotY: Math.PI/2,
            // WorkingRotZ: Math.PI,
            // workingCameraPosY: -1.8,

            CameraPosY: 8,
        }
    }
    // Desktops
    else if (width >= 1024){
        object = {
            objPosX: 2,
            objPosY: -10,
            objPosZ: -4,

            // objRotX: Math.PI/7,
            objRotX: Math.PI/2,
            objRotY: -Math.PI/3,
            objRotZ: 0,

            entryObjPosY: 0,

            ComponentsPosX: -3,
            ComponentPosY: 0,
            ComponentPosZ: -13,

            ComponentCameraPosY: 0,

            ComponentsRotX: 0,
            ComponentsRotY: Math.PI/2,
            ComponentsRotZ: 0,

            // WorkingPosX: 4,
            // WorkingPosZ: -20,
            // WorkingRotX: Math.PI/2,
            // WorkingRotY: 0,
            // WorkingRotZ: -Math.PI/2,
            // workingCameraPosY: 1.3,

            CameraPosY: 8,
        }
    }

    return object
}